module.exports = __webpack_public_path__ + "img/germany-blood-diseases-male.e4d08a36.png";